const MB_5 = 1024 * 1024 * 5;

export const DEFAULT = {
  MIN_PART_NUMBER: 1,
  MAX_PART_NUMBER: 1000,
  MIN_PART_SIZE: MB_5,
  QUEUE_SIZE: 4,
  ABORT_ON_FAILURE: true,
};
